/* eslint-disable */
import axios from '@/axios.js';

export const purchaseApi = {
  getPurchases(payload) {
    return axios.get('/transactions/purchases', {
      params: payload,
    });
  },
  getPurchase(id) {
    return axios.get(`/transactions/purchases/${id}`);
  },
};
